/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

export enum AppPath {
  ROOT = "/",
  STUDIO = "/studio",
  PROJECT_SHOW = "/projects/:projectUuid",
  ANONYMOUS_RECORDING = "/sessions/:anonymousAccessKey",
  TEMPLATE_CREATE = "/templates/:templateId",
  ENHANCE_SPEECH = "/enhance",
  ENHANCE_SPEECH_V2_EARLY_ACCESS_PAGE = "/enhance-speech-v2",
  ENHANCE_SPEECH_INFLUENCERS_PAGE = "/enhancespeech",
  MICROPHONE_CHECK = "/miccheck",
  FEATURES = "/features",
  PLANS = "/plans",
  RECORD_PAGE = "/record-your-podcast-for-free",
  TRANSCRIPTION_PAGE = "/transcribe-audio-with-adobe-podcast",
  EDIT_AUDIO_PAGE = "/edit-audio-with-adobe-podcast",
  CONVERT_AUDIO_TO_VIDEO_PAGE = "/convert-audio-to-video-with-adobe-podcast",
  GUIDES = "/guides/:guidePageSlug?",
}
